import { Link } from "react-router-dom";

const stats = [
  { value: "120+", label: "出品与参与作品" },
  { value: "18", label: "行业奖项荣誉" },
  { value: "9", label: "深耕影视行业（年）" },
  { value: "300+", label: "合作创作者" },
];

export default function StatsStrip() {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-2 gap-6 px-4 py-8 md:grid-cols-4 md:px-6 md:py-10">
        {stats.map((item) => (
          <div key={item.label} className="text-center md:text-left">
            <p className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">
              {item.value}
            </p>
            <p className="mt-1 text-xs text-foreground-600 md:text-sm">{item.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}